export default __webpack_public_path__ + "static/media/flipper.6a0d65a6.png";